import { logEvent } from "./logger";

export function reportVital(metric) {
  const payload = {
    id: metric?.id,
    name: metric?.name,
    value: metric?.value,
    rating: metric?.rating,
    delta: metric?.delta,
  };
  logEvent("info", "web-vital", payload);
}
